import type { Act } from '@models/Act'
import type { Entity, EntitySearchValues } from '@models/Entity'
import type { EntityKpi } from '@models/EntityKpi'

export type Subproces = {
  _id: string
  status: keyof typeof SubprocesStatus
  type: keyof typeof SubprocesTypes
  assignedTo: string
  dueDate?: string // ISO date string
  created: Act
  completed?: Act
  changed: string // ISO date string
  entity: Entity
  log?: SubprocesLog[]
  rejectionCount: number
  searchValues: EntitySearchValues
  myList: boolean
  kpi?: EntityKpi
  labels?: string[]

  // schouw only
  schouwDatum?: string // ISO date string
}

export const SubprocesTypesAansluiting = {
  schouw: 'Schouw',
} as const

export const SubprocesTypesHoofdleiding = {
  bodem: 'Bodem',
  netcheck: 'Netcheck',
} as const

export const SubprocesTypes = {
  ...SubprocesTypesAansluiting,
  ...SubprocesTypesHoofdleiding,
} as const

const SubprocesStatusShared = {
  created: 'Nieuw',
  done: 'Afgerond',
  paused: 'Gepauzeerd',
  in_progress: 'In uitvoering',
} as const

// deze twee zijn expliciet gesplitst ivm de filter dropdowns van HL en AL
export const SubprocesStatusAansluiting = {
  planned: 'Gepland',
  rejected: 'Afgekeurd',
  cancelled: 'Geannuleerd',
  ...SubprocesStatusShared,
} as const

export const SubprocesStatusHoofdleiding = {
  // bodem specific
  samenstellen_aanvraag: 'Aanvraag samenstellen',
  review: 'Bodemadvies opstellen',
  aanvullend_onderzoek_nodig: 'Aanvullend bodemonderzoek nodig',
  // netcheck specific
  criteria_klant_verzamelen: 'Criteria klant verzamelen',
  netcheck_opstarten: 'Netcheck opstarten',

  ...SubprocesStatusShared,
} as const

/**
 * Voor labels van statusen, zie getStatusLabelForType in subproces-util, deze houdt rekening met type van subproces en sommige uitzondering obv type
 */
export const SubprocesStatus = {
  ...SubprocesStatusAansluiting,
  ...SubprocesStatusHoofdleiding,
}

export type SubprocesLog = {
  status: keyof typeof SubprocesStatus
  dueDate?: string

  // schouw only
  schouwDatum?: string // ISO date string
} & Act
